<template>
  <div class="chat">
    <!-- {{formParamSRSt}} -->
    <!-- {{linkRows}} -->
    <div class="chat-box">
      <div class="chats">
        <div class="chat chat-right">
          <div class="chat-body">
            <div class="chat-bubble">
              <div class="chat-content" style=" overflow-wrap: break-word;">
                <div class="chat-img-group clearfix"
                  v-if="formParamQRSt.header.message_type == 'image' && formParamQRSt.header.button_type != 'list_text'">
                  <a v-if="attachmentUrl" class="chat-img-attach" href="javascript:void(0)">
                    <img style="max-height:200px;" alt :src="attachmentUrl" />
                  </a>
                  <div v-else class="qr-preview-media-empty">
                    <i class="fa fa-picture-o"></i>
                    <span>Media gambar belum dipilih.</span>
                  </div>
                </div>
                <div class="chat-video-group clearfix"
                  v-if="formParamQRSt.header.message_type == 'video' && formParamQRSt.header.button_type != 'list_text'">
                  <video v-if="attachmentUrl" class="qr-preview-video" controls :src="attachmentUrl"></video>
                  <div v-else class="qr-preview-media-empty">
                    <i class="fa fa-video-camera"></i>
                    <span>Media video belum dipilih.</span>
                  </div>
                </div>
                <ul class="attach-list"
                  v-if="formParamQRSt.header.message_type == 'document' && formParamQRSt.header.button_type != 'list_text'">
                  <li v-if="attachmentUrl">
                    <i class="fa fa-file"></i>
                    <a :href="attachmentUrl" target="_blank" rel="noopener noreferrer">
                      {{ formParamQRSt.header.media_name || "File" }}
                    </a>
                  </li>
                  <li v-else class="qr-preview-media-empty">
                    <i class="fa fa-file-o"></i>
                    <span>Media dokumen belum dipilih.</span>
                  </li>
                </ul>
                <p v-html="previewFormattedMessage" v-if="formParamQRSt.header.message != ''"
                  v-linkified></p>
                <p v-else-if="!isMediaType" class="qr-preview-empty-message">Pesan akan tampil di sini.</p>
                <span v-html="formParamQRSt.header.footer_message" class="text-muted" style="font-size:10px;"
                  v-linkified v-if="formParamQRSt.header.footer_message_status == true"></span>
                <template v-if="formParamQRSt.detail_button.length">
                  <div v-if="formParamQRSt.header.button_type == 'text_reply'">
                    <div class="text-left" v-for="(rowVal, idx) in formParamQRSt.detail_button" :key="idx">
                      <span v-html="getTextReplyLabelById(rowVal.auto_reply_button_id, idx)"></span>
                    </div>
                  </div>
                  <div v-if="formParamQRSt.header.button_type == 'button'">
                    <div class="text-center" v-for="(rowVal, idx) in formParamQRSt.detail_button" :key="idx">
                      <div class="user-add-shedule-list" v-if="rowVal.auto_reply_button_id != '' && idx < 3">
                        <a href="javascript:void(0)">
                          <i class="fa fa-tags"></i>
                          {{ getButtonLabelById(rowVal.auto_reply_button_id) }}
                        </a>
                      </div>
                    </div>
                  </div>
                  <div v-if="formParamQRSt.header.button_type == 'list_text'">
                    <table class="table table-nowrap">
                      <template v-for="(rowVal, idx) in formParamQRSt.detail_button">
                        <tr v-if="rowVal.auto_reply_button_id != ''" :key="idx">
                          <td>
                            <label
                              :for="rowVal.auto_reply_button_id">{{ getButtonLabelById(rowVal.auto_reply_button_id) }}</label>
                          </td>
                          <td>
                            &nbsp;
                            <input disabled name="radio_list_text" class="form-check-input"
                              :id="rowVal.auto_reply_button_id" type="radio" />
                          </td>
                        </tr>
                      </template>
                    </table>
                  </div>
                  <div v-if="formParamQRSt.header.button_type == 'link'">
                    <div class="text-center" v-for="(rowVal, idx) in formParamQRSt.detail_button" :key="idx">
                      <div class="user-add-shedule-list" v-if="rowVal.auto_reply_button_id != '' && idx < 3">
                        <a href="javascript:void(0)" v-html="getLinkLabelById(rowVal.auto_reply_button_id)"></a>
                      </div>
                    </div>
                  </div>
                </template>
              </div>

              <div class="chat-content" style=" overflow-wrap: break-word;"
                v-if="(formParamQRSt.header.message_type == 'image' || formParamQRSt.header.message_type == 'document') && formParamQRSt.header.button_type == 'list_text'">
                <div class="chat-img-group clearfix"
                  v-if="formParamQRSt.header.message_type == 'image' && formParamQRSt.header.button_type == 'list_text'">
                  <a class="chat-img-attach" href="javascript:void(0)">
                    <img style="max-height:200px;" alt :src="formParamQRSt.header.image_url" />
                  </a>
                </div>
                <ul class="attach-list"
                  v-if="formParamQRSt.header.message_type == 'document' && formParamQRSt.header.button_type == 'list_text'">
                  <li>
                    <i class="fa fa-file"></i>
                    <a :href="formParamQRSt.header.image_url" target="_blank">File</a>
                  </li>
                </ul>
              </div>
              <div class="qr-preview-time">
                {{ timestamp }}
                <i
                  v-for="check in checkCount"
                  :key="check"
                  class="fa fa-check"
                  :class="{ 'qr-preview-check-double': checkCount > 1 }"
                ></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr v-if="formParamQRSt.header.is_enable_away_message_status == true" />
      <div class="chats" v-if="formParamQRSt.header.is_enable_away_message_status == true">
        <div class="chat chat-right">
          <div class="chat-body">
            <div class="chat-bubble">
              <div class="chat-content">
                <p v-html="messageFilter(formParamQRSt.header.message_away)"
                  v-if="formParamQRSt.header.message_away != ''" v-linkified></p>
                <span v-html="formParamQRSt.header.footer_message" class="text-muted" style="font-size:10px;"
                  v-linkified v-if="formParamQRSt.header.footer_message_status == true"></span>
                <template v-if="formParamQRSt.detail_button_away.length">
                  <div v-if="formParamQRSt.header.button_type_away_message == 'button'">
                    <div class="text-center" v-for="(rowVal, idx) in formParamQRSt.detail_button_away" :key="idx">
                      <div class="user-add-shedule-list" v-if="rowVal.auto_reply_button_id != ''">
                        <a href="javascript:void(0)">
                          <i class="fa fa-tags"></i>
                          {{ getButtonLabelById(rowVal.auto_reply_button_id) }}
                        </a>
                      </div>
                    </div>
                  </div>
                  <div v-if="formParamQRSt.header.button_type_away_message == 'link'">
                    <div class="text-center" v-for="(rowVal, idx) in formParamQRSt.detail_button_away" :key="idx">
                      <div class="user-add-shedule-list" v-if="rowVal.auto_reply_button_id != ''">
                        <a href="javascript:void(0)" v-html="getLinkLabelById(rowVal.auto_reply_button_id)"></a>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatWhatsAppText } from "@/utils/whatsappFormat";

export default {
  components: {},
  props: {
    buttonsRows: {
      type: Array,
      default: () => [{ button_text: "" }]
    },
    linkRows: {
      type: Array
    },
    textReplyRows: {
      type: Array
    },
    previewData: {
      type: Object,
      default: null
    },
    timestamp: {
      type: String,
      default: "08:50"
    },
    checkCount: {
      type: Number,
      default: 1
    },
    safeFormat: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isLoading: false
    };
  },
  watch: {},
  computed: {
    formParamQRSt() {
      return this.previewData || this.$store.state.automation.formParamQRSt;
    },
    previewFormattedMessage() {
      const replaced = this.replacePreviewVariables(
        this.formParamQRSt.header.message || ""
      );
      // Default Quick Reply tetap memakai formatter lama; Auto Follow Up
      // memakai formatter yang meng-escape HTML karena konten berasal dari form.
      return this.safeFormat
        ? formatWhatsAppText(replaced)
        : this.$util.formatMessage(replaced);
    },
    attachmentUrl() {
      const url = String(this.formParamQRSt.header.image_url || "").trim();
      if (!url || /^javascript:/i.test(url)) {
        return "";
      }
      return url;
    },
    isMediaType() {
      return ["image", "video", "document"].indexOf(
        this.formParamQRSt.header.message_type
      ) !== -1;
    }
  },
  methods: {
    replacePreviewVariables(message) {
      const samples = {
        first_name: "Jojo",
        last_name: "Pratama",
        phone_number: "6281234567890",
        email: "jojo@example.com",
        month_current: "10",
        month_current_name: "Oktober",
        year_current: "2026",
        today: "29",
        yesterday: "28",
        month_ago: "9",
        month_ago_name: "September",
        year_ago: "2025"
      };

      return String(message || "").replace(
        /\$\{([a-zA-Z0-9_]+)\}/g,
        (match, variableName) => {
          return samples[variableName] !== undefined
            ? samples[variableName]
            : "[" + variableName + "]";
        }
      );
    },
    getTextReplyLabelById(id, idx) {
      let arr = this.textReplyRows.find(msgs => msgs.id === id);
      if (arr != null && typeof arr.title != "undefined") {
        return (idx + 1) + '. ' + arr.title;
      } else {
        return "";
      }
    },
    getButtonLabelById(id) {
      let arr = this.buttonsRows.find(msgs => msgs.id === id);
      if (arr != null && typeof arr.button_text != "undefined") {
        return arr.button_text;
      } else {
        return "";
      }
    },
    getLinkLabelById(id) {
      let arr = this.linkRows.find(msgs => msgs.id === id);
      if (arr != null && typeof arr.button_text != "undefined") {
        if (arr.button_type == "call") {
          return '<i class="fa fa-phone"></i> ' + arr.button_text;
        } else {
          return '<i class="fa fa-external-link"></i> ' + arr.button_text;
        }
      } else {
        return "";
      }
    },
    messageFilter(message) {
      return message.replace(/\r?\n/g, "<br />");
    }
  },
  async created() { },
  beforeDestroy() { },
  mounted() {
    if ($(".datetimepicker").length > 0) {
      $(".datetimepicker").datetimepicker({
        format: "DD/MM/YYYY",
        icons: {
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          next: "fa fa-angle-right",
          previous: "fa fa-angle-left"
        }
      });
    }
    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function (e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "buttons-add"
};
</script>

<style scoped>
.qr-preview-time {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 4px;
  margin-top: 6px;
  color: #8696a0;
  font-size: 10px;
}

.qr-preview-time .fa {
  color: #53bdeb;
  font-size: 10px;
}

.qr-preview-time .qr-preview-check-double + .qr-preview-check-double {
  margin-left: -5px;
}

.qr-preview-video {
  display: block;
  width: 100%;
  max-height: 200px;
  background: #000;
  border-radius: 6px;
}

.qr-preview-media-empty {
  display: flex;
  align-items: center;
  gap: 7px;
  margin-bottom: 6px;
  padding: 9px 10px;
  color: #6b7c75;
  background: rgba(255, 255, 255, 0.55);
  border: 1px dashed rgba(15, 23, 42, 0.15);
  border-radius: 6px;
  font-size: 11px;
  font-style: italic;
}

.qr-preview-media-empty .fa {
  font-size: 14px;
}

.qr-preview-empty-message {
  margin: 0;
  color: #8696a0;
  font-size: 12px;
  font-style: italic;
}
</style>


// WEBPACK FOOTER //
// src/views/automation/quickReply/preview.vue